import { render } from "./PromotionBanner.vue?vue&type=template&id=5d15e1b2&scoped=true"
import script from "./PromotionBanner.vue?vue&type=script&lang=js"
export * from "./PromotionBanner.vue?vue&type=script&lang=js"

import "./PromotionBanner.vue?vue&type=style&index=0&id=5d15e1b2&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d15e1b2"]])

export default __exports__